import { accountsPost } from './api';
import { isUndefinedOrNull } from './type_guards';
export async function getLatestOrgTOS(orgId) {
  try {
    const url = `accounts/getLatestOrgTOS`;
    const body = { orgId };
    const latestOrgTOS = await accountsPost(url, body);
    if (!isUndefinedOrNull(latestOrgTOS.getLatestOrgTOS)) {
      return latestOrgTOS.getLatestOrgTOS;
    }
    return [];
  } catch (error) {
    console.error('error getting latest org TOS', error);
    return [];
  }
}
